import { IResponse } from './../models/util';

import axios from '../helpers/axios'
import { logError } from '../services';
import { ISetsAndPalettesOptions, ISetsAndPalettesOptionsPayload } from '../models';

const baseUrl = '/api/option-sets';

export const getOptionSetsData = async (optionSetType: string, filters?: {
  page?: number;
  perPage?: number | string;
  name?: string;
  sortBy?: string;
  sortDirection?: string;

}): Promise<IResponse<ISetsAndPalettesOptions[]>> => {
  try {
    const { data } = await axios.get(`${baseUrl}/${optionSetType}`, {params: filters});

    return data;
  } catch (error: any) {
    logError(error, 'getOptionStatus failed');
    return Promise.reject(error?.response?.data);
  }
};

export const createOptionSet = async (payload: ISetsAndPalettesOptionsPayload): Promise<void> => {
  try {
    const { data } = await axios.post(`${baseUrl}`, payload);

    return data;
  } catch (error: any) {
    logError(error, 'createOptionSet failed');
    return Promise.reject(error?.response?.data);
  }
};

export const updateOptionSet = async (optionSetId : number, name: string, optionSetType: string, payload: ISetsAndPalettesOptionsPayload): Promise<void> => {
  try {
    const { data } = await axios.put(`${baseUrl}/${optionSetId}`, payload, {params: {optionSetType, name}});

    return data;
  } catch (error: any) {
    logError(error, 'updateOptionSet failed');
    return Promise.reject(error?.response?.data);
  }
};

export const deleteOptionSet = async (optionSetId : number): Promise<void> => {
  try {
    const { data } = await axios.delete(`${baseUrl}/${optionSetId}`, {params: {optionSetId}});

    return data;
  } catch (error: any) {
    logError(error, 'updateOptionSet failed');
    return Promise.reject(error?.response?.data);
  }
};